/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { Box, Grid } from '@mui/material';
import UIGrid from '../uigrid';
import { resultsData, calculatedResultsData } from './resultsData';
import { argo_report } from './outputdata';

const DetailedResults = ({ data, recovery, product, isFeedComposition }) => {
  const [feedData] = useState(data.feed_ppm || null);
  const [brineData] = useState(data.waste_dict || null);
  const [updatedResultsData, setUpdatedResultsData] = useState(resultsData);
  const [argo_report_data, setArgoReportData] = useState(data?.calculation_results);
  const recoveryValue = isFeedComposition==='feed' ? recovery: 0 || 0;

  useEffect(() => {
    // Update resultsData with new feed and brine values
    const fmt = (v, d = 2) => (v != null && !Number.isNaN(Number(v)) ? Number(v).toFixed(d) : undefined);

    const updated = resultsData.map(item => {
      const baseFeed = feedData?.[item.chemicalName];
      const feedValueDefault = baseFeed?.toFixed ? baseFeed.toFixed(2) : (typeof baseFeed === 'number' ? baseFeed.toFixed(2) : item.raw);

      let feedValue = feedValueDefault;
      let brineValue = brineData?.ppm_dict?.[recoveryValue]?.[item.chemicalName]?.toFixed(2) || item.braine;

      if (item.chemicalName === 'ph') {
        brineValue = brineData?.ph_dict?.[recoveryValue]?.toFixed(2) || item.braine;
      }
      if (item.chemicalName === 'tds') {
        brineValue = brineData?.tds_dict?.[recoveryValue]?.toFixed(2) || item.braine;
      }
      if (item.chemicalName === 'CO2') {
        brineValue = brineData?.ppm_dict?.[recoveryValue]?.CO2?.toFixed(2) || item.braine;
      }
      if (item.chemicalName === 'CCPP') {
        brineValue = brineData?.ccpp_dict?.[recoveryValue]?.toFixed(2) || item.braine;
      }
      if (item.chemicalName === 'Ionic Strength') {
        brineValue = brineData?.ionicstr_dict?.[recoveryValue]?.toFixed(4) || item.braine;
      }

      // Prefer LSI; if LSI exists show LSI and hide S&DI, else show S&DI and hide LSI
      if (item.chemicalName === 'LSI') {
        feedValue = (fmt(feedData?.LSI) ?? item.raw);
        brineValue = (fmt(brineData?.lsi_dict?.[recoveryValue]) ?? item.braine);
      } else if (item.chemicalName === 'S&DI') {
        feedValue = (fmt(feedData?.['S&DI']) ?? item.raw);
        brineValue = (fmt(brineData?.sdi_dict?.[recoveryValue]) ?? item.braine);
      }

      return {
        ...item,
        raw: feedValue,
        braine: brineValue
      };
    });

    // Prefer LSI if present anywhere; otherwise prefer S&DI.
    const preferLSI = Object.keys(feedData).includes('LSI');
    const filtered = updated.filter(row => row.chemicalName !== (preferLSI ? 'S&DI' : 'LSI'));

    setUpdatedResultsData(filtered);
  }, []);
  const getSaturationIndex = (value, recoveryIndex) => {
    if (!value) return { key: '-', value: '-' };
    const lsi = value.LSI?.[recoveryIndex];
    if (Object.keys(feedData).includes('LSI')) {
      return { key: 'LSI', value: lsi?.toFixed(2) ?? '-' };
    }
    const sdi = value['S&DI']?.[recoveryIndex];
    return { key: 'S&DI', value: sdi?.toFixed(2) ?? '-' };
  };

  const getCCPPAndLimit = (ccppValue, product, saturationKey) => {
    const activeDualequationCCPP = JSON.parse(localStorage.getItem('Active_DualequationCCPP')) || {};
    if (activeDualequationCCPP?.[product] === 1) {
      const limitText =
        saturationKey === 'LSI'
          ? 'CCPP < 1000 or LSI < 3'
          : 'CCPP < 1000 or S&DI < 3';
      return {
        limit: limitText,
        ccpp: ccppValue != null ? ccppValue.toFixed(2) : '-'
      };
    }
    return { limit: '3', ccpp: '-' };
  };
  const recoveryIndex = recovery;
  const calciumCarbonateData = argo_report_data?.['Calcium Carbonate'];
  const saturationInfo = getSaturationIndex(calciumCarbonateData, recoveryIndex);
  const { limit: caco3Limit, ccpp: ccppDisplay } =
    getCCPPAndLimit(calciumCarbonateData?.CCPP?.[recoveryIndex], product, saturationInfo.key);
  const activeDualequationCCPP = JSON.parse(localStorage.getItem('Active_DualequationCCPP')) || {};
  const isDualEq = activeDualequationCCPP?.[product] === 1;
  const isshowMgOH2 = ['MDC714', 'MDC712', 'MDC704i', 'MDC712E'].includes(product);
  const caco3_Keys = Object.keys(argo_report_data?.['Calcium Carbonate'] || {});
  // Build CaCO3 row conditionally (only this row changes layout)
  const caCO3Row = isDualEq
    ? {
      Key: 'CaCO3',
      KeyText: 'Calcium Carbonate',
      // Column headers will be: CCPP | (LSI or S&DI) | Limit
      saturation: ccppDisplay ?? '-',              // CCPP value goes under second column
      limits: saturationInfo.value ?? '-',         // Saturation index value under third column
      max: caco3Limit ?? ' '                       // Limit text under fourth column
    }
    : {
      Key: 'CaCO3',
      KeyText: 'Calcium Carbonate',
      saturation: saturationInfo.value ?? '-',     // Saturation value (LSI or S&DI)
      limits: caco3Limit,                          // Limit text
      max: ccppDisplay ?? ' '                       // CCPP value (or '-')
    };

  const key_value = [
    caCO3Row,
    { Key: '-', KeyText: '-', saturation: 'Saturation', limits: 'Limit', max: '% of Max'},
    { Key: 'CaSO4', KeyText: 'Calcium Sulphate', saturation: argo_report_data?.Saturation?.[recoveryValue]?.CaSO4 ?? '-', limits: argo_report_data?.Limits?.[product]?.CaSO4 ?? '-', max: argo_report_data?.['% of Max']?.[recoveryValue]?.[product]?.CaSO4?.toFixed(2) ?? '-'},
    { Key: 'BaSO4', KeyText: 'Barium Sulphate', saturation: argo_report_data?.Saturation?.[recoveryValue]?.BaSO4 ?? '-', limits: argo_report_data?.Limits?.[product]?.BaSO4 ?? '-', max: argo_report_data?.['% of Max']?.[recoveryValue]?.[product]?.BaSO4?.toFixed(2) ?? '-'},
    { Key: 'SrSO4', KeyText: 'Strontium Sulphate', saturation: argo_report_data?.Saturation?.[recoveryValue]?.SrSO4 ?? '-', limits: argo_report_data?.Limits?.[product]?.SrSO4 ?? '-', max: argo_report_data?.['% of Max']?.[recoveryValue]?.[product]?.SrSO4?.toFixed(2) ?? '-'},
    { Key: 'CaF2', KeyText: 'Calcium Fluoride', saturation: argo_report_data?.Saturation?.[recoveryValue]?.CaF2 ?? '-', limits: argo_report_data?.Limits?.[product]?.CaF2 ?? '-', max: argo_report_data?.['% of Max']?.[recoveryValue]?.[product]?.CaF2?.toFixed(2) ?? '-'},
    { Key: 'CaHPO4', KeyText: 'Calcium Phosphate', saturation: argo_report_data?.Saturation?.[recoveryValue]?.CaHPO4 ?? '-', limits: argo_report_data?.Limits?.[product]?.CaHPO4 ?? '-', max: argo_report_data?.['% of Max']?.[recoveryValue]?.[product]?.CaHPO4?.toFixed(2) ?? '-'},
    ...(isshowMgOH2 ? [{ Key: 'MgOH2', KeyText: 'Magnesium Hydroxide', saturation: argo_report_data?.Saturation?.[recoveryValue]?.MgOH2 ?? '-', limits: argo_report_data?.Limits?.[product]?.MgOH2 ?? '-', max: argo_report_data?.['% of Max']?.[recoveryValue]?.[product]?.MgOH2?.toFixed(2) ?? '-'}] : []),
    { Key: '-', KeyText: '-', saturation: 'Brine Conc', limits: 'Limit', max: '% of Max'},
    { Key: 'Fe', KeyText: 'Iron', saturation: argo_report_data?.Saturation?.[recoveryValue]?.Fe ?? '-', limits: argo_report_data?.Limits?.[product]?.Fe ?? '-', max: argo_report_data?.['% of Max']?.[recoveryValue]?.[product]?.Fe?.toFixed(2) ?? '-'},
    { Key: 'Mn', KeyText: 'Manganese', saturation: argo_report_data?.Saturation?.[recoveryValue]?.Mn ?? '-', limits: argo_report_data?.Limits?.[product]?.Mn ?? '-', max: argo_report_data?.['% of Max']?.[recoveryValue]?.[product]?.Mn?.toFixed(2) ?? '-'},
    { Key: 'Al', KeyText: 'Aluminium', saturation: argo_report_data?.Saturation?.[recoveryValue]?.Al ?? '-', limits: argo_report_data?.Limits?.[product]?.Al ?? '-', max: argo_report_data?.['% of Max']?.[recoveryValue]?.[product]?.Al?.toFixed(2) ?? '-'},
    { Key: 'SiO2', KeyText: 'Silica', saturation: argo_report_data?.Saturation?.[recoveryValue]?.SiO2 ?? '-', limits: argo_report_data?.Limits?.[product]?.SiO2 ?? '-', max: argo_report_data?.['% of Max']?.[recoveryValue]?.[product]?.SiO2?.toFixed(2) ?? '-'}
  ];
  const properties = [
    { hdata: '', tag: 'Ion', disabled: true, datatype: 'text' },
    { hdata: 'Raw (ppm)', tag: 'raw', disabled: null, datatype: 'number' },
    { hdata: 'Brine (ppm)', tag: 'braine', disabled: null, datatype: 'number' },
    // { hdata: 'ppm as CaCO3', tag: 'ppmAsCaCO3', disabled: null, datatype: 'number' }
  ];
  const calculatedResultsProperties = isDualEq
    ? [
      { hdata: '', tag: 'Key', disabled: true, datatype: 'text' },
      { hdata: 'CCPP', tag: 'saturation', disabled: true, datatype: 'text' },                // second column header changed
      { hdata: saturationInfo.key ?? '-', tag: 'limits', disabled: true, datatype: 'text' }, // third column header is original saturation key
      { hdata: 'Limit', tag: 'max', disabled: true, datatype: 'text' }                       // fourth column header becomes Limit
    ]
    : [
      { hdata: '', tag: 'Key', disabled: true, datatype: 'text' },
      { hdata: saturationInfo.key ?? '-', tag: 'saturation', disabled: true, datatype: 'text' },
      { hdata: 'Limit', tag: 'limits', disabled: true, datatype: 'text' },
      { hdata: ' ', tag: 'max', disabled: true, datatype: 'text' }
    ];
  localStorage.setItem('Calcium_Carbonate_value', JSON.stringify({[saturationInfo.key]: saturationInfo.value, Limit: caco3Limit, [isDualEq ? 'CCPP' : '']: isDualEq ? ccppDisplay : ''}));
  useEffect(() => {
    $('.custom-calculatedResults-grid .row_2').addClass('highlightHeader');
    $(isshowMgOH2 ? '.custom-calculatedResults-grid .row_9' : '.custom-calculatedResults-grid .row_8').addClass('highlightHeader');
  }, []);
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={5} className="modal-background">
          <h4>Water Composition</h4>
          <Box
            className="custom-Results-grid"
            style={{
              height: 'auto',
              width: 'auto',
              marginRight:'20px'
            }}
          >
            <UIGrid
              data={updatedResultsData}
              properties={properties}
              // onblur={handleAfterEdit}
            />
          </Box>
        </Grid>
        <Grid item xs={7} className="modal-background">
          <h4>Saturation Index</h4>
          <Box
            className="custom-Results-grid custom-calculatedResults-grid"
            style={{
              height: 'auto',
              width: 'auto',
              marginRight:'20px'
            }}>
            <UIGrid
              data={key_value}
              properties={calculatedResultsProperties}
              // onblur={handleAfterEdit}
            />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default DetailedResults;
